import { render, staticRenderFns } from "./SingleMessage.vue?vue&type=template&id=d05dbcc4&scoped=true&"
import script from "./SingleMessage.vue?vue&type=script&lang=js&"
export * from "./SingleMessage.vue?vue&type=script&lang=js&"
import style0 from "./SingleMessage.vue?vue&type=style&index=0&id=d05dbcc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05dbcc4",
  null
  
)

export default component.exports